export const NODE_NAME = 'tab';
